module.exports = "/_next/static/images/27-1-42ba9e4a5e039a0aca0a674a0f10d163.jpg";